export default __webpack_public_path__ + "static/media/road-map-bottom.74a9a30f.png";